const ChartActionTypes = {
  FETCH_CHART_DATA_START: 'FETCH_CHART_DATA_START',
  FETCH_CHART_DATA_SUCCESS: 'FETCH_CHART_DATA_SUCCESS',
  FETCH_CHART_DATA_FAILURE: 'FETCH_CHART_DATA_FAILURE',
};

export default ChartActionTypes;
